import React from 'react';
import { Box, Card, CardContent, CardActions, Typography, Button, Divider } from '@mui/material';
import { Icon } from '@iconify/react';
import PropTypes from 'prop-types';

export const TrainingSessionDetailMobileBlock = ({ workoutsData, onRowClick, onTrainingInfoClick }) => {
  return (
    <Box sx={{ padding: 2 }}>
      {workoutsData.map((workout) => (
        <Card key={workout.id} sx={{ marginBottom: 2 }}>
          <CardContent>
            <Typography variant="h6" color="textPrimary">{workout.workoutName}</Typography>
            <Typography variant="body2" color="textSecondary">{workout.categoryName}</Typography>
            <Divider sx={{ marginY: 1 }} />
            <Typography variant="body2">Time: {workout.timeMinutes > 0 ? workout.timeMinutes : '-'}</Typography>
            <Typography variant="body2">Calories: {workout.calories > 0 ? workout.calories : '-'}</Typography>
            <Typography variant="body2">Distance: {workout.distanceKm > 0 ? workout.distanceKm : '-'}</Typography>
            <Typography variant="body2">Sets: {workout.sets > 0 ? workout.sets : '-'}</Typography>
            <Typography variant="body2">Repetitions: {workout.repetitions > 0 ? workout.repetitions : '-'}</Typography>
          </CardContent>
          <CardActions>
            <Button 
              size="small" 
              color="primary" 
              onClick={() => onRowClick(workout)} 
              disabled={workout.isUpdated}
            >
              {workout.isUpdated ? 'View' : 'Edit'}
            </Button>
            <Icon 
              icon="carbon:view-filled" 
              onClick={() => onTrainingInfoClick(workout)} 
              style={{
                marginLeft: '10px', 
                width: '24px', 
                height: '24px', 
                color: workout.isUpdated ? 'green' : 'gray'
              }} 
            />
          </CardActions>
        </Card>
      ))}
    </Box>
  );
};

TrainingSessionDetailMobileBlock.propTypes = {
  workoutsData: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      workoutName: PropTypes.string.isRequired,
      categoryName: PropTypes.string.isRequired,
      timeMinutes: PropTypes.number,
      calories: PropTypes.number,
      distanceKm: PropTypes.number,
      sets: PropTypes.number,
      repetitions: PropTypes.number,
      isUpdated: PropTypes.bool,
    })
  ).isRequired,
  onRowClick: PropTypes.func.isRequired,
  onTrainingInfoClick: PropTypes.func.isRequired,
};
